import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Lenis from 'lenis';
import { Toaster } from 'sonner';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { Marquee } from './components/Marquee';
import { ValueStrip } from './components/ValueStrip';
import { WhatIsKrug } from './components/WhatIsKrug';
import { Showcase } from './components/Showcase';
import { PeopleSection } from './components/PeopleSection';
import { BusinessSection } from './components/BusinessSection';
import { EventsSection } from './components/EventsSection';
import { IskraSection } from './components/IskraSection';
import { MiniGames } from './components/MiniGames';
import { WhyKrug } from './components/WhyKrug';
import { WhoFor } from './components/WhoFor';
import { Waitlist } from './components/Waitlist';
import { StoreCTA } from './components/StoreCTA';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { CookieBanner } from './components/CookieBanner';
import LegalPage from './pages/LegalPage';
import AdminPage from './pages/AdminPage';
import SupportPage from './pages/SupportPage';
import { LangProvider } from './i18n/LangContext';
import { useAnalytics } from './analytics';

const useLenis = () => {
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);
};

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  useAnalytics();
  return null;
};

const Landing = () => (
  <div data-testid="landing-page" className="bg-krug-navy">
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <ValueStrip />
      <WhatIsKrug />
      <Showcase />
      <PeopleSection />
      <BusinessSection />
      <EventsSection />
      <IskraSection />
      <MiniGames />
      <WhyKrug />
      <WhoFor />
      <Waitlist />
      <StoreCTA />
      <FAQ />
    </main>
    <Footer />
  </div>
);

function App() {
  useLenis();
  return (
    <LangProvider>
      <BrowserRouter>
        <ScrollManager />
        <div className="noise-overlay" aria-hidden="true" />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/privacy" element={<LegalPage pageKey="privacy" />} />
          <Route path="/terms" element={<LegalPage pageKey="terms" />} />
          <Route path="/community-guidelines" element={<LegalPage pageKey="community-guidelines" />} />
          <Route path="/contact" element={<LegalPage pageKey="contact" />} />
          <Route path="/support" element={<SupportPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
        <Toaster theme="dark" position="bottom-center" />
        <CookieBanner />
      </BrowserRouter>
    </LangProvider>
  );
}

export default App;
